import React from "react";
import DomainCertificate from "../../Containers/DomainManagementContainer/DomainCertificate";

const DomainCertificateContainer =(props)=>{
	return (
		<DomainCertificate  />
	)
}

export default DomainCertificateContainer;